import React from 'react';
import * as S from './SuitabilityTestConfirm.style';
import { SignatureComponent } from '../Signature/SignatureComponent';
import { ISignature } from "../../services/SignaturesService";
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import moment from "moment";
import UserIdentitiesService, { UserIdentityType } from '@/services/UserIdentitiesService';
import SuitabilityTestService, { ISuitabilityTest } from '@/services/SuitabilityTestsService';
import { obfuscatePhone } from '@/utils/ObfuscatePhone';
import { selectDraftSuitabilityTest } from './selectDraftSuitabilityTest';
import { isSuitabilityLimitReachedError, resolveSuitabilityTestError } from './suitabilityTestErrorMessages';

const SuitabilityTestConfirm = ({userIdentityId, returnRoute, cancelRoute, returnNavigationState, onLimitReached}:
{
    userIdentityId: number,
    returnRoute: string,
    cancelRoute: string,
    /** Estado al volver tras firmar. La contratación no lo pasa. */
    returnNavigationState?: object,
    /** 409 de los 30 días. La renovación vuelve al listado. */
    onLimitReached?: (message: string) => void
}) =>
{
    const history = useHistory();
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState<unknown>();
    const { state } = useLocation<any>();
    const [userIdentity, setUserIdentity] = useState<UserIdentityType>();
    const [suitabilityTest, setSuitabilityTest] = useState<ISuitabilityTest>();
    const [statusError, setStatusError] = useState<string | null>(null);

    const processExpirationDate = (signatures: ISignature[]) =>
    {
        if(signatures !== undefined && signatures.length > 0)
        {
            // eslint-disable-next-line array-callback-return
            signatures.map((signature: ISignature) =>
            {
                if(signature && typeof signature.expiresAt === "string")
                {
                    signature.expiresAt = moment(signature.expiresAt).toDate();
                }
            });
        }
    }

    let defaultSignatures: any = state?.signatures;
    processExpirationDate(defaultSignatures);

    const [signatures, setSignatures] = useState(defaultSignatures);

    useEffect(() =>
    {
        if(userIdentityId !== undefined)
        {
            UserIdentitiesService.getUserIdentityWithSuitabilityTests(userIdentityId).then((userIdentity: UserIdentityType) =>
            {
                setUserIdentity(userIdentity);
                const draft = selectDraftSuitabilityTest(userIdentity.suitabilityTests, state?.suitabilityTestId);
                if(draft)
                {
                    setSuitabilityTest(draft);
                }
                setIsLoaded(true);
            },
            (error) =>
            {
                setError(error);
                setIsLoaded(true);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userIdentityId]);

    const maskedSignPhone = obfuscatePhone(userIdentity?.signPhone);

    const updateStatus = () =>
    {
        setStatusError(null);
        if(suitabilityTest !== undefined && suitabilityTest.id !== undefined && suitabilityTest.answers !== undefined)
        {
            SuitabilityTestService.patchSuitabilityTest(suitabilityTest.id, { status: "SIGNED" }).then(() =>
            {
                history.push(returnRoute, returnNavigationState);
            },
            (requestError: unknown) =>
            {
                if(isSuitabilityLimitReachedError(requestError) && onLimitReached)
                {
                    onLimitReached(resolveSuitabilityTestError(requestError));
                    return;
                }

                setError(requestError);
            });
        }
        else
        {
            setStatusError("No se ha podido confirmar el test de idoneidad.");
        }
    };

    return(
        <React.Fragment>
            <S.Cont>
                <S.MainCont>
                    {!isLoaded && (<Spinner size={SpinnerSize.large} />)}
                    {isLoaded && userIdentity !== undefined &&
                    (
                        <React.Fragment>
                            <SignatureComponent
                                signatures={signatures}
                                userIdentities={[userIdentity]}
                                title="Test de idioneidad de la inversión"
                                submitButtonText="Firmar y enviar"
                                cancelButtonText="Volver"
                                headerTextArea={maskedSignPhone
                                    ? `Te hemos enviado un código SMS al número ${maskedSignPhone} para verificar la identidad del interviniente.`
                                    : "Te hemos enviado un código SMS para verificar la identidad del interviniente."}
                                backButtonText="Volver"
                                onBackButtonClicked={() => history.push(cancelRoute)}
                                onCancelButtonClicked={() => history.push(cancelRoute)}
                                requestNewCodeButtonText="Recibir nuevo código"
                                onNewCodeSended={(signatures: any) =>
                                {
                                    processExpirationDate(signatures);
                                    setSignatures(signatures);
                                }}
                                onSignatureChanged={(signatures: any) =>
                                {
                                    processExpirationDate(signatures);
                                    setSignatures(signatures);
                                }}
                                onSigned={updateStatus}
                            />

                            {statusError && (
                                <div>{statusError}</div>
                            )}
                            {error && (
                                <div>{resolveSuitabilityTestError(error)}</div>
                            )}
                        </React.Fragment>
                    )}
                </S.MainCont>
            </S.Cont>
        </React.Fragment>
    );
};

export default SuitabilityTestConfirm;